import { API_SERVICE } from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        paymentRequests: null,
        genericPaymentLink: null,
        latestPaymentRequest: null,
        requestHistory: []
    },
    mutations: {
        SET_PAYMENT_REQUESTS(state, data) {
            state.paymentRequests = data;
            state.genericPaymentLink = data.GenericPaymentLink;
            state.latestPaymentRequest = data.LatestPaymentRequest;
            state.requestHistory = data.RequestHistory;
        },
        CLEAR_PAYMENT_REQUESTS(state) {
            state.paymentRequests = null;
            state.genericPaymentLink = null;
            state.latestPaymentRequest = null;
            state.requestHistory = [];
        }
    },
    getters: {
        paymentRequests:(state) => {
            return state.paymentRequests;
        },
        hasPaymentRequests: (state) => {
            return state.paymentRequests !== null;
        },
        genericPaymentLink: (state) => {
            return state.genericPaymentLink;
        },
        latestPaymentRequest: (state) => {
            return state.latestPaymentRequest;
        },
        requestHistory: (state) => {
            return state.requestHistory;
        },
        totalOutstandingAmount: (state) => {
            if (!state.requestHistory) return 0;
            return state.requestHistory.reduce((total, request) => {
                return total + request.AmountLeftToPay;
            }, 0);
        },
        totalPaidAmount: (state) => {
            if (!state.requestHistory) return 0;
            return state.requestHistory.reduce((total, request) => {
                return total + request.AmountPaid;
            }, 0);
        },
        requestsByState: (state) => (requestState) => {
            if (!state.requestHistory) return [];
            return state.requestHistory.filter(request => request.RequestState === requestState);
        }
    },
    actions: {
        async getPaymentRequests({ commit }, payload) {
            try {
                const params = {
                    body: {
                        clientName: payload.clientName,
                        personID: payload.personID,
                    }
                };

                const response = await API_SERVICE.post("peoplePortalRestAPI", "/accounts/payment-requests", params);

                if (response.status === "200") {
                    commit("SET_PAYMENT_REQUESTS", response.data);
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    return {
                        success: false,
                        error: response.error
                    };
                }
            } catch (error) {
                console.error("Error fetching payment requests:", error);
                return {
                    success: false,
                    error: error.message
                };
            }
        },
        clearPaymentRequests({ commit }) {
            commit("CLEAR_PAYMENT_REQUESTS");
        }
    }
};